import { render, staticRenderFns } from "./CoopnetMachineLogoComponent.vue?vue&type=template&id=5b315a80&"
import script from "./CoopnetMachineLogoComponent.vue?vue&type=script&lang=js&"
export * from "./CoopnetMachineLogoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports